export default __webpack_public_path__ + "static/media/logout.f159ee15.png";